import React from "react";
import { Table } from "reactstrap";
import { BoolCell } from "../components/grid/cells/BoolCell";
import { BadgeCell } from "../components/grid/cells/BadgeCell";

const Icd10Codes = ({ codes }) => {
  if (!codes.length) {
    return <span className="text-muted">Any</span>;
  }

  return codes.map((code) => <BadgeCell key={code} value={code} color="secondary" className="me-1" />);
};

export const CoverageResultsTable = ({ results }) => {
  return (
    <Table responsive hover>
      <thead>
        <tr>
          <th>Payor</th>
          <th>Code</th>
          <th>Covered</th>
          <th>Plan Type</th>
          <th>ICD-10 Codes</th>
          <th>Step Therapy</th>
          <th>ST Details</th>
          <th>Source</th>
        </tr>
      </thead>
      <tbody>
        {results.map((row, index) => (
          <tr key={index}>
            <td>{row.payor_name}</td>
            <td>{row.procedure_code}</td>
            <td>
              <BoolCell value={row.covered} nullLabel="Unknown" />
            </td>
            <td>{row.plan_type}</td>
            <td>
              <Icd10Codes codes={row.icd10_codes} />
            </td>
            <td>
              <BoolCell value={row.step_therapy} nullLabel="Unknown" />
            </td>
            <td>{row.st_details}</td>
            <td>
              <BadgeCell value={row.source} color={row.source === "MMIT" ? "info" : "success"} outline />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
